import { FetchAssertsService } from '@/packages/query-state/shared/services/FetchAssertsService';
import { type IQueryStateAppContext } from '@/packages/query-state/shared/types/appContext';

import {
  type ICianApiSiteV1GetUserDataByRequestResponse200,
  type TCianApiSiteV1GetUserDataByRequestResponse_1,
  createCianApiSiteV1GetUserDataByRequestModel,
  fetchCianApiSiteV1GetUserDataByRequest,
} from '@/repositories/generated/shared/monolith-python/cian-api/site/v1/get-user-data-by-request';

export function fetchCianApiSiteV1GetUserDataByRequestService(
  applicationContext: IQueryStateAppContext,
): Promise<TCianApiSiteV1GetUserDataByRequestResponse_1> {
  const { httpApi, logger, custom } = applicationContext;

  const fetchAssertsService = new FetchAssertsService(
    createCianApiSiteV1GetUserDataByRequestModel(),
    '@/shared/store/serverSide/monolith-python/cian-api/site/v1/get-user-data-by-request/internal/fetchService.ts',
    logger,
  );

  return fetchCianApiSiteV1GetUserDataByRequest<ICianApiSiteV1GetUserDataByRequestResponse200>({
    config: { subdomain: custom.subdomain },
    httpApi,
  }).then(
    result => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        default:
          throw fetchAssertsService.assertUnknownStatusCodeError(statusCode);
      }
    },
    error => {
      throw fetchAssertsService.assertUnknownServerError(error);
    },
  );
}
